import { createContext } from "react";

import { TabsVariantProps } from "./styles";

type TabsContextType = {
  lineLayoutId: string;
  activeElementClassName: string;
} & TabsVariantProps;

export const TabsContext = createContext<TabsContextType>({
  lineLayoutId: "",
  activeElementClassName: "",
  variant: "button",
  color: "spearmint",
  size: "38",
});
